import { render, staticRenderFns } from "./LogAlteracaoItem.vue?vue&type=template&id=63c35a78&scoped=true"
import script from "./LogAlteracaoItem.vue?vue&type=script&lang=js"
export * from "./LogAlteracaoItem.vue?vue&type=script&lang=js"
import style0 from "./LogAlteracaoItem.vue?vue&type=style&index=0&id=63c35a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c35a78",
  null
  
)

export default component.exports